import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import GlobalStyles from '../../global-styles';
import { Box, FormControl, InputLabel, TextField } from '../../utils/material-ui-core';

interface ITitleValueProps {
  title: string;
  value: any;
  type: string;
  multiline: boolean;
}

const TitleValue = ({ title, value, type, multiline }: ITitleValueProps) => {
  const pageStyles = LocalPageStyles();
  const globalStyles = GlobalStyles();

  return (
    <Box className={globalStyles.formikContainer}>
      {type === "title" ? (
        <FormControl fullWidth={true}>
          <InputLabel>{title}</InputLabel>
        </FormControl>
      ) : (
        <TextField fullWidth={true} disabled multiline={multiline} label={title} type={type} value={value === null ? "" : value} className={pageStyles.textBox} />
      )}
    </Box>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    textBox: {
      "& .MuiInputBase-input.Mui-disabled": {
        color: "#636363 ",
      },
    },
  })
);

export default TitleValue;
